const route = {
    path: '/releaseRequests',
    meta: { authClass: 'protected' },
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "release" */ '../../components/views/releaseRequests/requests.vue'),
            }
        },
        {
            path: ':type/:id',
            components: {
                default:
                    () => import(/* webpackChunkName: "release" */ '../../components/views/releaseRequests/request.vue'),
            }
        },
    ],
}

module.exports = route;